<app-navbar></app-navbar>

<main class="py-5 px-2 p-md-5">
    <section class="row">
        <div class="d-none d-lg-block col-lg-3 col-xxl-2">
            <app-sidebar></app-sidebar>
        </div>
        <div class="col-12 col-lg-9 col-xxl-10">
            <div class="tab-content" id="pills-tabContent">
                <p class="text-muted">
                        <strong>¡¡¡IMPORTANTE!!!</strong><br>
                        Todos los documentos correspondientes a convenios <strong>SOLO SERÁN VÁLIDOS CON LAS FIRMAS DE AMBAS PARTES</strong>. 
                        Adicionalmente, toda copia digital <strong>SOLO SERÁ VÁLIDA CON SU RESPECTIVA FIRMA ELECTRÓNICA AVANZADA</strong>.
                    </p>
                    <br>
                <div class="refresh-button">
                    <button>
                        <a title="Refrescar" data-toggle="tooltip" (click)="refreshDatatableFromDOM()">
                        Actualizar <i class="fa fa-refresh" id="table-refresh"></i>
                    </a></button>
                </div>
                
                <!-- Contenedor con posición relativa para el overlay -->
                <div class="table-container" style="position: relative;">
                    <div class="tab-pane fade show active" id="firmas-pendiendes" role="tabpanel" aria-labelledby="firmas-pendiendes-tab" tabindex="0">
                        <table class="table table-bordered table-hover table-document-pending" width="100%" cellspacing="0">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nombre documento</th>
                                    <th>Jefatura</th>
                                    <th>Fecha</th>
                                    <th>Estado</th>
                                    <th>Opciones</th>
                                </tr>
                            </thead>
                            <tbody></tbody>
                            <tfoot></tfoot>
                        </table>                    
                    </div>
                </div>                
            </div>
        </div>
    </section>
    
    <!-- Modal para vista previa de PDF usando Angular -->
    <div class="modal-overlay" *ngIf="showPdfModal" (click)="closePdfModal()">
        <div class="modal-container" (click)="$event.stopPropagation()">
            <div class="modal-header">
                <h4>Vista Previa del Documento</h4>
                <div class="modal-close">
                    <button type="button" (click)="closePdfModal()">
                        <i class="fa fa-times"></i> Cerrar
                    </button>
                </div>
            </div>
            <div class="modal-body" style="position: relative;">
                <iframe [src]="currentPdfUrl" width="100%" height="600px" frameborder="0"></iframe>
            </div>
        </div>
    </div>
</main>

<app-footer></app-footer>
